// components/CurrentInvestmentForm.js
import React, { useState, useEffect } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function MutualFunds() {
  const { state, actions } = useAppContext();

  const [value,setValues] = useState({
    debtMF: state.debtMF || '',
    equityMF: state.equityMF || '',
    hybridMF: state.hybridMF || '',
    invits: state.invits || ''
  });

  useEffect(() => {
    setValues({
    debtMF: state.debtMF || '',
    equityMF: state.equityMF || '',
    hybridMF: state.hybridMF || '',
    invits: state.invits || '',
    });
  }, [state.debtMF, state.equityMF, state.hybridMF, state.invits])
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2}}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Mutual Funds and ETFs
          </Typography>
        <Typography variant="body1" component="h2" gutterBottom>
         Liquid, Debt & Arbritrage Funds
        </Typography>
      
          <TextField
             //label="Debt MF"
            placeholder='total value of debt funds'
            value={formatNumber(value.debtMF)}
            onChange={handleChange('debtMF')}
            fullWidth
            type="tel"
            inputMode="numeric"
            aria-label="Debt funds allocation in rupees"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
        Equity MF & ETF
        </Typography>
        

          <TextField
             //label="Equity MF"
             placeholder='total value of equity funds'
            value={formatNumber(value.equityMF)}
            onChange={handleChange('equityMF')}
            fullWidth
            type="tel"
            inputMode="numeric"
            aria-label="Equity mutual funds and ETF allocation in rupees"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
         Hybrid Funds
        </Typography>
        
          <TextField
             //label="Hybrid MF"
             placeholder='total value of hybrid funds'
            value={formatNumber(value.hybridMF)}
            onChange={handleChange('hybridMF')}
            fullWidth
            type="tel"
            inputMode="numeric"
            aria-label="Hybrid funds allocation in rupees"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
          <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
         InvITs/REITs
        </Typography>

          <TextField
            // label="InvITs/REITs"
            placeholder='total value of InvITs and REITs'
            value={formatNumber(value.invits)}
            onChange={handleChange('invits')}
            fullWidth
            type="tel"
            inputMode="numeric"
            aria-label="InvITs and REITs allocation in rupees"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
          </Box>
        </Box>
      </CardContent>
</Box>
  );

}

export default MutualFunds;